const trimString = (string, length) => {
  const trimmedString =
    string.length > length ? string.substring(0, length - 3) + "..." : string;

  return trimmedString;
};

export default trimString;
